import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
const COUNTDOWN_DURATION = 10 * 60; // 10 minutes in seconds
const STORAGE_KEY = 'proyecto-patriarca-countdown';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState<number>(COUNTDOWN_DURATION);
  const [isUrgent, setIsUrgent] = useState(false);
  useEffect(() => {
    // Initialize timer from localStorage or set new expiry time
    const storedExpiry = localStorage.getItem(STORAGE_KEY);
    const now = Date.now();
    let expiryTime: number;
    if (storedExpiry) {
      expiryTime = parseInt(storedExpiry, 10);
      const remaining = Math.max(0, Math.floor((expiryTime - now) / 1000));
      if (remaining === 0) {
        // Timer expired, reset it
        expiryTime = now + COUNTDOWN_DURATION * 1000;
        localStorage.setItem(STORAGE_KEY, expiryTime.toString());
        setTimeLeft(COUNTDOWN_DURATION);
      } else {
        setTimeLeft(remaining);
      }
    } else {
      // First visit, set new expiry time
      expiryTime = now + COUNTDOWN_DURATION * 1000;
      localStorage.setItem(STORAGE_KEY, expiryTime.toString());
      setTimeLeft(COUNTDOWN_DURATION);
    }
    // Update countdown every second
    const interval = setInterval(() => {
      const now = Date.now();
      const remaining = Math.max(0, Math.floor((expiryTime - now) / 1000));
      setTimeLeft(remaining);
      setIsUrgent(remaining <= 120); // Last 2 minutes
      if (remaining === 0) {
        // Reset timer when it reaches 0
        expiryTime = now + COUNTDOWN_DURATION * 1000;
        localStorage.setItem(STORAGE_KEY, expiryTime.toString());
        setTimeLeft(COUNTDOWN_DURATION);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <motion.div animate={isUrgent ? {
    scale: [1, 1.05, 1]
  } : {}} transition={isUrgent ? {
    duration: 1,
    repeat: Infinity
  } : {}} className={`inline-flex items-center gap-3 px-6 py-3 rounded-lg ${isUrgent ? 'bg-red-600' : 'bg-red-700'} shadow-lg`} data-id="element-1">
      <Clock className="w-5 h-5 text-white" aria-hidden="true" data-id="element-2" />
      <div className="flex flex-col items-start" data-id="element-3">
        <span className="font-body text-xs text-white/90 uppercase tracking-wide" data-id="element-4">
          ¡Oferta Expira En:
        </span>
        <span className="font-heading text-2xl md:text-3xl text-white tabular-nums" data-id="element-5">
          {formattedTime}
        </span>
      </div>
    </motion.div>;
}